// The sample numbers of NIT, Germination Test and TGW ("Set samples", Edit Trial, the wizard)
import { triStateValue } from './triState';

/** Each sample number with the activity (flag) it belongs to. */
export const SAMPLE_FIELDS = [
  { field: 'NIT_Samples', flag: 'NIT', label: 'NIT Samples' },
  { field: 'GT_Samples', flag: 'GerminationTest', label: 'Germination Test Samples' },
  { field: 'TGW_Samples', flag: 'TGW', label: 'TGW Samples' },
];

/** Whether the activity is Yes (No, To be decided and not set: no samples). */
export const takesSamples = (trial, flag) => triStateValue(trial?.[flag]) === 1;

/** Whether the trial has any activity that takes samples: only then is "Set samples" offered. */
export const hasSamples = (trial) => SAMPLE_FIELDS.some(({ flag }) => takesSamples(trial, flag));

/**
 * The number of samples to show or report, null while its activity is not Yes: a number set before the activity
 * became No or To be decided is kept in the database, but not shown (customer point 23).
 */
export function shownSamples(trial, field) {
  const { flag } = SAMPLE_FIELDS.find((s) => s.field === field);
  return takesSamples(trial, flag) ? trial?.[field] ?? null : null;
}
